import { useMutation } from '@tanstack/react-query';
import { getAuthService } from '../services/auth.service';

const useLogOut = () => {
    const useLogOutMutation = useMutation({
        mutationFn: () => getAuthService().logout(),
    });
    return {
        useLogOutMutation,
    };
};

export default useLogOut;
